// MOMKIS - Rail d'avis à défilement continu, réutilisable (source unique).
// Utilisé tel quel par sections/momkis-home-reviews.liquid,
// sections/momkis-collection-reviews.liquid et sections/momkis-pdp-reviews.liquid.
// Le sélecteur de carte est configurable via data-momkis-card-selector sur le
// conteneur [data-momkis-reviews-widget] (les 3 sections passent
// ".momkis-reviews-card", des cartes rendues en Liquid — jamais de donnée
// d'avis créée/modifiée/dupliquée au sens structuré : le widget Judge.me
// natif et son JSON-LD vivent dans un conteneur séparé, hors de ce rail).
//
// Mouvement : défilement automatique CONTINU et lent (pas d'autoplay par
// étapes). Boucle sans téléportation grâce à UN clone du jeu de cartes
// (aria-hidden, non focusable). Pause au survol / focus clavier / toucher /
// molette, reprise propre. prefers-reduced-motion => aucun défilement auto.
// Aucun overflow => aucun mouvement (rien à faire défiler).
(function () {
  var SPEED_PX_PER_SEC = 25; // mouvement lent, premium

  function getCardSelector(root) {
    return root.dataset.momkisCardSelector || '.jdgm-rev';
  }

  function initCarousel(root, track, cardSelector) {
    if (track.dataset.momkisInit) return;
    track.dataset.momkisInit = 'true';
    track.classList.add('momkis-reviews-track');

    var childSel = ':scope > ' + cardSelector;
    var originals = Array.prototype.slice.call(track.querySelectorAll(childSel));
    if (originals.length === 0) return;

    var prevBtn = root.querySelector('[data-momkis-reviews-prev]');
    var nextBtn = root.querySelector('[data-momkis-reviews-next]');

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var clonesBuilt = false;
    var loopWidth = 0;
    var rafId = null;
    var lastT = 0;
    var paused = false;
    var resumeTimer = null;
    // Position accumulée en JS : scrollLeft peut être arrondi à l'entier par
    // le navigateur, ce qui bloquerait un incrément sous-pixel par frame.
    var pos = 0;
    var syncPos = false; // resynchroniser pos depuis scrollLeft (après scroll manuel / flèche)

    function firstOriginal() {
      return track.querySelector(childSel);
    }

    function cardStep() {
      var first = firstOriginal();
      var st = getComputedStyle(track);
      var gap = parseFloat(st.columnGap || st.gap) || 20;
      var width = first ? first.getBoundingClientRect().width : 300;
      return width + gap;
    }

    function hasOverflow() {
      return track.scrollWidth - track.clientWidth > 4;
    }

    function buildClones() {
      if (clonesBuilt) return;
      var frag = document.createDocumentFragment();
      originals.forEach(function (node) {
        var clone = node.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.dataset.momkisClone = 'true';
        var focusables = clone.querySelectorAll('a, button, input, select, textarea, [tabindex]');
        Array.prototype.forEach.call(focusables, function (el) {
          el.setAttribute('tabindex', '-1');
        });
        if (clone.matches && clone.matches('a, button')) clone.setAttribute('tabindex', '-1');
        frag.appendChild(clone);
      });
      track.appendChild(frag);
      clonesBuilt = true;
      measureLoop();
    }

    function measureLoop() {
      var base = firstOriginal();
      var firstClone = track.querySelector('[data-momkis-clone="true"]');
      if (base && firstClone) {
        loopWidth = firstClone.offsetLeft - base.offsetLeft;
      }
    }

    function frame(t) {
      if (!lastT) lastT = t;
      var dt = (t - lastT) / 1000;
      lastT = t;
      if (dt > 0.1) dt = 0.1; // onglet réactivé : pas de saut

      if (paused || syncPos) {
        // Pendant une pause / après une interaction : suivre la position
        // réelle pour repartir exactement d'où l'utilisateur a laissé le rail.
        pos = track.scrollLeft;
        syncPos = false;
      } else if (loopWidth > 0) {
        pos += SPEED_PX_PER_SEC * dt;
        if (pos >= loopWidth) pos -= loopWidth;
        else if (pos < 0) pos += loopWidth;
        track.scrollLeft = pos;
      }
      rafId = window.requestAnimationFrame(frame);
    }

    function startContinuous() {
      if (rafId != null) return;
      track.style.scrollSnapType = 'none';
      lastT = 0;
      pos = track.scrollLeft;
      rafId = window.requestAnimationFrame(frame);
    }

    function stopContinuous() {
      if (rafId != null) window.cancelAnimationFrame(rafId);
      rafId = null;
      track.style.scrollSnapType = ''; // rend la main au CSS (scroll-snap)
    }

    function pause() {
      paused = true;
      if (resumeTimer) {
        clearTimeout(resumeTimer);
        resumeTimer = null;
      }
    }
    function resume() {
      syncPos = true;
      paused = false;
    }
    function resumeSoon(ms) {
      if (resumeTimer) clearTimeout(resumeTimer);
      resumeTimer = setTimeout(function () {
        syncPos = true;
        paused = false;
        resumeTimer = null;
      }, ms || 2200);
    }

    root.addEventListener('mouseenter', pause);
    root.addEventListener('mouseleave', resume);
    root.addEventListener('focusin', pause);
    root.addEventListener('focusout', resume);
    track.addEventListener('touchstart', pause, { passive: true });
    track.addEventListener('touchend', function () { resumeSoon(2500); }, { passive: true });
    track.addEventListener('pointerdown', pause);
    track.addEventListener('pointerup', function () { resumeSoon(2500); });
    track.addEventListener('wheel', function () { pause(); resumeSoon(1800); }, { passive: true });

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        pause();
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
        resumeSoon(2500);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        pause();
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
        resumeSoon(2500);
      });
    }

    function applyMode() {
      var over = hasOverflow();
      if (prevBtn) prevBtn.hidden = !over;
      if (nextBtn) nextBtn.hidden = !over;

      if (over && !reducedMotion.matches) {
        buildClones();
        measureLoop();
        startContinuous();
      } else {
        stopContinuous();
      }
    }

    if (reducedMotion.addEventListener) {
      reducedMotion.addEventListener('change', applyMode);
    } else if (reducedMotion.addListener) {
      reducedMotion.addListener(applyMode);
    }

    var resizeT;
    window.addEventListener('resize', function () {
      clearTimeout(resizeT);
      resizeT = setTimeout(function () {
        if (clonesBuilt) measureLoop();
        applyMode();
      }, 200);
    });

    applyMode();
  }

  function translate(root) {
    if (window.momkisTranslateJudgeme) window.momkisTranslateJudgeme(root);
  }

  function tryInit(root) {
    var cardSelector = getCardSelector(root);
    var firstCard = root.querySelector(cardSelector);
    if (!firstCard || !firstCard.parentElement) return false;
    initCarousel(root, firstCard.parentElement, cardSelector);
    return true;
  }

  function watch(root) {
    translate(root);
    if (tryInit(root)) return;

    var observer = new MutationObserver(function () {
      translate(root);
      if (tryInit(root)) observer.disconnect();
    });
    observer.observe(root, { childList: true, subtree: true });
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  function init() {
    document.querySelectorAll('[data-momkis-reviews-widget]').forEach(watch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
